export enum ShapeVariant {
  Blob01 = 'Blob01',
  Blob02 = 'Blob02',
  Blob03 = 'Blob03',
  Blob04 = 'Blob04',
  Blob05 = 'Blob05',
  Blob06 = 'Blob06',
  Shadow01 = 'Shadow01',
  Shadow02 = 'Shadow02',
  Shadow03 = 'Shadow03',
  Shadow04 = 'Shadow04',
  Shadow05 = 'Shadow05',
  Shadow06 = 'Shadow06',
}

export enum ShapeType {
  Blob = 'Blob',
  Shadow = 'Shadow',
}
